import { useMe } from "logics/account"

export default function useHeader() {
  const { state = {} } = useMe()

  return {
    me: state,
  }
}
